/**
 * Transport léger (sessionStorage) de la commande COD réellement créée ET
 * vérifiée côté serveur, entre le formulaire et la page /commande-confirmee.
 * Aucune donnée n'est écrite tant que Shopify n'a pas confirmé la commande.
 */
export type ConfirmedOrderLine = {
  name: string;
  variant?: string;
  quantity: number;
  price: number;
};

export type ConfirmedOrder = {
  orderNumber: string;
  fullName: string;
  city: string;
  total: number;
  lines: ConfirmedOrderLine[];
  createdAt: number;
};

const KEY = "sunset.confirmed-order";

export function storeConfirmedOrder(order: ConfirmedOrder) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(order));
  } catch {
    /* stockage indisponible : la page affichera l'état de repli */
  }
}

export function readConfirmedOrder(): ConfirmedOrder | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConfirmedOrder;
    if (!parsed?.orderNumber || !Array.isArray(parsed.lines)) return null;
    return parsed;
  } catch {
    return null;
  }
}
